import { render, staticRenderFns } from "./visitList.vue?vue&type=template&id=1ddde28e&scoped=true&"
import script from "./visitList.vue?vue&type=script&lang=js&"
export * from "./visitList.vue?vue&type=script&lang=js&"
import style0 from "./visitList.vue?vue&type=style&index=0&id=1ddde28e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddde28e",
  null
  
)

export default component.exports